import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useState, useEffect } from 'react'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import { format, startOfDay, endOfDay } from 'date-fns'
import { useQueryState, parseAsString } from 'nuqs'
import useQueryGetPlayerWithReturnLossReceive from '@/modules/manage-player/api/hooks/useQueryGetPlayerWithReturnLossReceive'
import PlayerWithReturnLossReceiveListing from '@/modules/manage-player/components/PlayerWithReturnLossReceive/components/PlayerWithReturnLossReceiveListing'

type SortOrder = 'asc' | 'desc' | undefined

function PlayerWithReturnLossReceivePage() {
	const { pageSize, currentPage, searchQuery, channelFilter } =
		useTablePagination()
	const { dateFilter, setDateFilter } = useDateFilter()
	const [dateRange, setDateRange] = useQueryState(
		'dateRange',
		parseAsString.withDefault(''),
	)

	useEffect(() => {
		if (!dateFilter.startDate && !dateFilter.endDate && dateRange !== 'all') {
			const today = new Date()
			setDateFilter({
				startDate: format(startOfDay(today), 'yyyy-MM-dd'),
				endDate: format(endOfDay(today), 'yyyy-MM-dd'),
			})
			setDateRange('today')
		}
	}, [
		dateFilter.startDate,
		dateFilter.endDate,
		dateRange,
		setDateFilter,
		setDateRange,
	])

	const [returnLossAmountSort, setReturnLossAmountSort] =
		useState<SortOrder>('desc')
	const [returnLossTimeSort, setReturnLossTimeSort] = useState<SortOrder>()

	const handleSort = (columnId: string, order: SortOrder) => {
		if (columnId === 'totalReturnLossAmount') {
			setReturnLossAmountSort(order)
			setReturnLossTimeSort(undefined)
		} else if (columnId === 'totalReturnLossTime') {
			setReturnLossTimeSort(order)
			setReturnLossAmountSort(undefined)
		}
	}

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		phone: searchQuery,
		channelName: channelFilter || undefined,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
		returnLossAmountSort,
		returnLossTimeSort,
	}

	const { data, isLoading } = useQueryGetPlayerWithReturnLossReceive(payload)

	return (
		<PageContainer>
			<PlayerWithReturnLossReceiveListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
				onSort={handleSort}
			/>
		</PageContainer>
	)
}

const GuardedPlayerWithReturnLossReceivePage = withUserPermission(
	PlayerWithReturnLossReceivePage,
	{
		permissionType: PermissionType.Read,
		permissionKey: [PermissionKeys.MANAGE_PLAYER],
	},
)

export default GuardedPlayerWithReturnLossReceivePage
